import { chain, filter, find, get, map, reduce, some, sumBy } from 'lodash';
import * as moment from 'moment';
import { Operation } from '../../const/CancelModel';
import { OthersFeesType } from '../../const/OthersFeesType';
import _ from 'lodash';
import { PaymentType } from '../../const/PaymentType';
/* eslint-disable */
export default {
  assemblePnrItemModel
};

function assemblePnrItemModel(pnr) {
  const departureFlight = find(pnr.flights, flight => flight.flightType === 'DEPARTURE');
  const returnFlight = find(pnr.flights, flight => flight.flightType === 'RETURN');
  let dateTimeUTC = moment.utc(pnr.date).format('YYYY-MM-DDTHH:mm:ss');
  let localDateTime = moment
    .utc(dateTimeUTC)
    .local()
    .format('YYYY-MM-DDTHH:mm:ss');
  const txAlteracaoObj = getValueTaxAlteracaoRebook(pnr.payments);
  const valueTaxaAlteracao = txAlteracaoObj.length > 0 ? txAlteracaoObj[0].value : 0;
  const mapValuesSplit = getMapValuesSplit(pnr);
  const totalMoney = getTotalMoney(pnr);

  return {
    pnrId: pnr.id,
    pnrDate: new Date(localDateTime),
    pnrNumber: pnr.pnrCode,
    partnerPnrMap: pnr.partnerPnrMap,
    principalContact: {
      tudoAzulNumber: pnr.contact.identifier
    },
    passengers: pnr.passengers.map(passenger => {
      return {
        id: passenger.id,
        name: passenger.name,
        lastName: passenger.lastName,
        gender: passenger.gender,
        birthDate: passenger.birthDate,
        email: passenger.email,
        passengerType: passenger.passengerType,
        ticketNumber: passenger.ticketNumber,
        adultResponsible: passenger.adultResponsible
      };
    }),

    payment: {
      items: chain(pnr.payments)
        .filter(
          payment =>
            (payment.paymentType === PaymentType.BOOKING || payment.paymentType === PaymentType.REBOOK) &&
            payment.currency === 'BRL'
        )
        .map(payment => {
          return {
            binCardNumber: payment.paymentCard.binCardNumber,
            cardNumberLast: payment.paymentCard.cardNumberLast,
            vendorCode: payment.paymentCard.vendorCode,
            value: payment.value,
						paymentType: payment.paymentType,
						paymentAdicional: payment.paymentAdicional
          };
        })
        .value()
    },

    cart: {
      items: [
        {
          departureFlight: assembleFlight(pnr, departureFlight),
          returnFlight: returnFlight ? assembleFlight(pnr, returnFlight) : null
        }
      ],
      total: getTotal(pnr, mapValuesSplit)
    },

    cancelInfo: assembleCancelInfo(pnr),
    passengerCancelInfo: assemblePassengerCancelInfo(pnr),
    status: pnr.status,
    statusTicket: pnr.statusTicket,
    statusAntiFraud: pnr.statusAntiFraud,
    fareOriginType: pnr.fareOriginType,
    totalPointPaymentAdicional: chain(pnr.payments)
      .filter(
        payment =>
          (payment.paymentType === PaymentType.BOOKING || payment.paymentType === PaymentType.REBOOK) &&
          payment.currency === 'POINTS' &&
          payment.paymentAdicional === true
      )
      .groupBy('currency')
      .map((payments, currency) => {
        return {
          currency: currency,
          value: sumBy(payments, 'value')
        };
      })
      .value(),

    totalValuePaymentAdicional: chain(pnr.payments)
      .filter(
        payment =>
          (payment.paymentType === PaymentType.BOOKING || payment.paymentType === PaymentType.REBOOK) &&
          payment.currency === 'BRL' &&
          payment.paymentAdicional === true
      )
      .groupBy('currency')
      .map((payments, currency) => {
        return {
          currency: currency,
          value: sumBy(payments, 'value')
        };
      })
      .value(),
    totalTxEmbarque: getTotalTaxValue(pnr, valueTaxaAlteracao, mapValuesSplit, totalMoney),
    pnrSplit: {
      pnrParent: assemblerPnrParent(pnr.pnrSplit),
      pnrChild: assemblerPnrChild(pnr.pnrSplit)
    },
    totalRebooking: assembleTotalRebooking(pnr.payments),
    totalTaxaAlteracao: txAlteracaoObj,
    isRebooking: isRebooking(pnr.payments),
    emdServices: assembleEmdService(pnr),
    installment: pnr.paymentInstallment ? pnr.paymentInstallment : null
  };
}

function getTotal(pnr, mapValuesSplit) {
  const splitAndInterestValue = Number(mapValuesSplit.get('BRL')) + getInterestsValue(pnr.paymentInstallment);
  return chain(pnr.payments)
    .filter(payment => payment.paymentType === PaymentType.BOOKING || payment.paymentType === PaymentType.REBOOK)
    .groupBy('currency')
    .map((payments, currency) => {
      return {
        currency: currency,
        value: sumBy(payments, 'value') -
          (currency === 'POINTS' ? mapValuesSplit.get('POINTS') : splitAndInterestValue)
      };
    })
    .value();
}

function getTotalTaxValue(pnr, valueTaxaAlteracao, mapValuesSplit, totalMoney) {
  return chain(pnr.payments)
    .filter(
      payment =>
        (payment.paymentType === PaymentType.BOOKING || payment.paymentType === PaymentType.REBOOK) &&
        payment.currency === 'BRL' &&
        payment.paymentAdicional === false
    )
    .groupBy('currency')
    .map((payments, currency) => {
      return {
        currency: currency,
        value:
          sumBy(payments, 'value') - valueTaxaAlteracao -  Number(mapValuesSplit.get('BRL')) - totalMoney - getInterestsValue(pnr.paymentInstallment)
      };
    })
    .value();
}

function getInterestsValue(paymentInstallment) {
	  return paymentInstallment ? paymentInstallment.interestsValue : 0;
}

function getValueTaxAlteracaoRebook(payments) {
  let paymentFilterRebooking = chain(payments)
    .filter(
      payment =>
        payment.paymentType === PaymentType.REBOOK &&
        payment.currency === 'BRL' &&
        payment.paymentAdicional === false &&
        payment.paymentOtherFees !== undefined &&
        payment.paymentOtherFees !== null &&
        payment.paymentOtherFees.length > 0
    )
    .value();

  return chain(paymentFilterRebooking)
    .map('paymentOtherFees')
    .flatMap()
    .filter(othersFeeType => othersFeeType.feeType === OthersFeesType.PENALTY)
    .groupBy('currency')
    .map(payment => {
      return {
        currency: 'BRL',
        value: sumBy(payment, 'value')
      };
    })
    .value();
}

function assemblerPnrParent(pnrSplit) {
  if (pnrSplit.pnrParent) {
    return {
      pnrId: pnrSplit.pnrParent.pnrId,
      pnrCode: pnrSplit.pnrParent.pnrCode,
      passengers: pnrSplit.pnrParent.passengers.map(passenger => {
        return {
          id: passenger.id,
          name: passenger.name,
          lastName: passenger.lastName,
          gender: passenger.gender,
          birthDate: passenger.birthDate,
          email: passenger.email,
          passengerType: passenger.passengerType,
          ticketNumber: passenger.ticketNumber,
          passengerPoints: passenger.passengerPoints,
          passengerTaxs: passenger.passengerTaxs,
          adultResponsible: passenger.adultResponsible
        };
      })
    };
  } else {
    return null;
  }
}

function assemblerPnrChild(pnrSplit) {
  if (pnrSplit.pnrChild && pnrSplit.pnrChild.length > 0) {
    return [
      pnrSplit.pnrChild.map(pnr => {
        return {
          pnrId: pnr.pnrId,
          pnrCode: pnr.pnrCode,
          passengers: pnr.passengers.map(passenger => {
            return {
              id: passenger.id,
              name: passenger.name,
              lastName: passenger.lastName,
              gender: passenger.gender,
              birthDate: passenger.birthDate,
              email: passenger.email,
              passengerType: passenger.passengerType,
              ticketNumber: passenger.ticketNumber,
              passengerPoints: passenger.passengerPoints,
              passengerTaxs: passenger.passengerTaxs,
              adultResponsible: passenger.adultResponsible
            };
          })
        };
      })
    ];
  } else {
    return [];
  }
}

function assembleFlight(pnr, flight) {
  return {
    originAirport: flight.originAirport,
    originAirportName: flight.originAirportName,
    finalDestination: flight.destinationAirport,
    finalDestinationName: flight.destinationAirportName,
    departureDate: formatDate(flight.departureDate),
    departureTime: formatTime(flight.departureDate),
    finalArrivalDate: formatDate(flight.arrivalDate),
    finalArrivalTime: formatTime(flight.arrivalDate),
    category: flight.category,
    baggage: flight.baggage,
    total: new Array({
      value: chain(pnr.passengers)
        .filter(passenger => !isPassengerSplited(pnr, passenger))
        .map('passengerPoints')
        .flatMap()
        .filter(passengerPoints => passengerPoints.flightId === flight.id)
        .sumBy('points')
        .value(),
      currency: 'POINTS'
    }),
    dateVariation: getDateVariation(flight.departureDate, flight.arrivalDate),
    hasExchangeAirport: some(
      map(flight.flightDetails, 'hasExchangeAirport'),
      hasExchangeAirport => hasExchangeAirport === true
    ),
    throughFlight: filter(flight.flightDetails, flightDetail => flightDetail.throughFlight === true)
      .length,
    flightGroup: flight.flightDetails.map(flightDetail => {
      return {
        origin: flightDetail.originAirport,
        destination: flightDetail.destinationAirport,
        departureDate: formatDate(flightDetail.departureDate),
        departureTime: formatTime(flightDetail.departureDate),
        arrivalDate: formatDate(flightDetail.arrivalDate),
        arrivalTime: formatTime(flightDetail.arrivalDate),
        dateVariation: getDateVariation(flightDetail.departureDate, flightDetail.arrivalDate),
        flightNumber: flightDetail.flightNumber,
        hasExchangeAirport: flightDetail.hasExchangeAirport,
        marketingCarrier: flightDetail.marketingCarrier,
        operatingCarrier: flightDetail.operatingCarrier,
        throughFlight: flightDetail.throughFlight,
        cabinCategory: flightDetail.cabinCategory
      };
    }),
    prices: chain(pnr.passengers)
      .groupBy('passengerType')
      .mapValues(passengers =>
        chain(passengers)
          .filter(passenger => !isPassengerSplited(pnr, passenger))
          .map('passengerPoints')
          .flatMap()
          .filter(passengerPoints => passengerPoints.flightId === flight.id)
          .value()
      )
      .map((value, key) => ({
        passenger: key,
        currency: 'POINTS',
        value: sumBy(value, 'points')
      }))
      .value(),
    money: assembleMoney(pnr, flight.id)
  };
}

function assemblePassengerCancelInfo(pnr) {
  return reduce(
    pnr.passengersCancelInfo,
    (passengerCancelInfoMap, current) => {
      passengerCancelInfoMap[current.passengerType] = {
        totalValue: current.totalValue,
        isReimbursable: current.refundType === 'REFUNDABLE',
        quantity: current.quantity
      };
      return passengerCancelInfoMap;
    },
    {}
  );
}

function assembleCancelInfo(pnr) {
  const paymentRefund = chain(pnr.payments)
    .filter(
      payment =>
        (payment.paymentType === PaymentType.BOOKING || payment.paymentType === PaymentType.REBOOK) &&
        payment.currency === 'BRL' &&
        payment.refundPayments &&
        payment.refundPayments.length > 0
    )
    .value();

  const paymentBookingAndRebook = chain(pnr.payments)
    .filter(
      payment =>
        (payment.paymentType === PaymentType.BOOKING || payment.paymentType === PaymentType.REBOOK) &&
        payment.currency === 'BRL'
    )
    .value();

  const paymentCancel = chain(pnr.payments)
    .filter(payment => payment.paymentType === PaymentType.CANCEL && payment.currency === 'BRL')
    .value();

  const totalPaymentBookingAndRebooking = chain(paymentBookingAndRebook)
    .sumBy('value')
    .value();

  const totalPaymentCancel = chain(paymentCancel)
    .sumBy('value')
    .value();

  if (paymentCancel && paymentCancel.length > 0) {
    return {
      balance: totalPaymentCancel,
      operation: Operation.PAYMENT,
      quotationDate: new Date('2019-04-22T21:47:43.600Z'),
      totalPayment: totalPaymentBookingAndRebooking - valueTotalRemoveTaxsAndMoneySplit(pnr),
      totalSimulate:
        totalPaymentCancel +
        totalPaymentBookingAndRebooking -
        valueTotalRemoveTaxsAndMoneySplit(pnr)
    };
  } else if (paymentRefund && paymentRefund.length > 0) {
    const balance = chain(paymentRefund)
      .map('refundPayments')
      .flatMap()
      .sumBy('value')
      .value();

    return {
      balance: balance,
      operation: Operation.REFUND,
      quotationDate: new Date('2019-04-22T21:47:43.600Z'),
      totalPayment: totalPaymentBookingAndRebooking - valueTotalRemoveTaxsAndMoneySplit(pnr),
      totalSimulate: assembleFeeCancel(pnr)
    };
  } else {
    return null;
  }
}

function assembleFeeCancel(pnr) {
	let total = 0.0;
	pnr.passengersCancelInfo.forEach(passenger => {
		total += passenger.totalValue;
	});  
	return Number(total).toFixed(2);
}

function assembleTotalRebooking(payments, totalPointsSplit) {
  let points = [];

  if (
    chain(payments)
      .filter(payment => payment.paymentType === PaymentType.REBOOK)
      .value().length
  ) {
    const pointsConsideringNegativeValues = chain(payments)
      .map(payment => {
        if (
          payment.paymentType === PaymentType.REBOOK &&
          payment.currency === 'POINTS' &&
          payment.transactionId == null
        ) {
          return {
            ...payment,
            value: payment.value * -1
          };
        } else return payment;
      })
      .value();

    points = chain(pointsConsideringNegativeValues)
      .filter(
        payment =>
          (payment.paymentType === PaymentType.REBOOK || payment.paymentType === PaymentType.BOOKING) &&
          payment.currency === 'POINTS'
      )
      .groupBy('currency')
      .map((payments, currency) => {
        return {
          currency: currency,
          value: sumBy(payments, 'value')  - totalPointsSplit
        };
      })
      .value();
  }

  const changeFee = chain(payments)
    .filter(payment => payment.paymentType === PaymentType.REBOOK && payment.currency === 'BRL')
    .orderBy('lastModifiedDate')
    .map(payments => {
      return {
        currency: payments.currency,
        value: payments.value
      };
    })
    .value();

  return {
    points: points.length ? points[0] : null,
    changeFee: changeFee.length ? changeFee[0] : null
  };
}

function getDateVariation(departureDateStr, arrivalDateStr) {
  const departureDate = moment(departureDateStr);
  const arrivalDate = moment(arrivalDateStr);
  let diff = arrivalDate.diff(departureDate, 'days');
  if (departureDate.date() !== arrivalDate.date()) {
    diff += 1;
  }
  return diff;
}

function formatDate(datetime) {
  return moment(datetime).format('DD/MM/YYYY');
}

function formatTime(datetime) {
  return moment(datetime).format('HH:mm');
}

function isRebooking(payments) {
  return (
    chain(payments)
      .filter(payment => payment.paymentType === PaymentType.REBOOK)
      .value().length > 0
  );
}

function assembleEmdService(pnr) {
  return pnr.emdServices;
}

function valueTotalRemoveTaxsAndMoneySplit(pnr) {
  let total = 0.0;
  pnr.passengers.forEach(passenger => {
    if (isPassengerSplited(pnr, passenger)) {
      passenger.passengerTaxs.forEach(passengerTax => {
        total += passengerTax.taxValue;
      });
    }
  });
  const totalRemoveMoney = getTotalMoneySplit(pnr);
  total += totalRemoveMoney;
  return Number(total).toFixed(2);
}

function valueTotalRemovePointsSplit(pnr) {
  let total = 0.0;
  pnr.passengers.forEach(passenger => {
    if (isPassengerSplited(pnr, passenger)) {
      passenger.passengerPoints.forEach(passengerPoints => {
        total += passengerPoints.points;
      });
    }
  });
  const pricesRemovePassegerSplit = Math.round(total).toFixed(0);
  return pricesRemovePassegerSplit;
}

function getTotalMoneySplit(pnr) {
  let total = 0.0;
  pnr.passengers.forEach(passenger => {
    if (isPassengerSplited(pnr, passenger)) {
      passenger.passengerPointsPlusMoney.forEach(passengerMoney => {
        total += passengerMoney.fare;
      });
    }
  });
  return Number(total);
}

function getMapValuesSplit(pnr) {
  return new Map([
    ['POINTS', valueTotalRemovePointsSplit(pnr)],
    ['BRL', valueTotalRemoveTaxsAndMoneySplit(pnr)]
  ]);
}

function isMoney(passengers) {
	return chain(passengers)
	    .map('passengerPointsPlusMoney')
		.filter(passengerPointsPlusMoney => passengerPointsPlusMoney && passengerPointsPlusMoney.length > 0)
		.value()
		.length > 0;
}

function assembleMoney(pnr, flightId) {
  const isMoneyFind = isMoney(pnr.passengers);
  if (isMoneyFind) {
    return chain(pnr.passengers)
      .groupBy('passengerType')
      .mapValues(passengers =>
        chain(passengers)
          .filter(passenger => !isPassengerSplited(pnr, passenger))
          .map('passengerPointsPlusMoney')
          .flatMap()
          .filter(passengerMoney => passengerMoney.flightId === flightId)
          .value()
      )
      .map((value, key) => ({
        passenger: key,
        currency: 'MONEY',
        value: sumBy(value, 'fare')
      }))
      .value();
  } else {
    return [];
  }
}

function getTotalMoney(pnr) {
  let result = 0;
  if (isMoney(pnr.passengers)) {
    result = Number(
      chain(pnr.passengers)
        .filter(passenger => !isPassengerSplited(pnr, passenger))
        .map('passengerPointsPlusMoney')
        .flatMap()
        .sumBy('fare')
        .value()
        .toFixed(2)
    );
  }
  return result;
}

function getTicketNumberFormated(ticketNumber) {
	return ticketNumber.replace(" ", "").toUpperCase();
}

export function getTravellerInfoKeyPassenger(passenger) {
  const birthDateFormat = moment(passenger.birthDate).format('YYYY-MM-DD');
  return String(`${passenger.name}${passenger.lastName}${birthDateFormat}`)
    .replace(' ', '')
    .toUpperCase();
}

export function isPassengerSplited(pnr, passengerVerify) {
  var isSplited = false;
  if (pnr.pnrSplit.pnrChild && pnr.pnrSplit.pnrChild.length > 0) {
    isSplited =
      _.chain(pnr.pnrSplit.pnrChild)
        .flatMap()
        .map('passengers')
        .flatMap()
        .filter(
          passengerChild =>
            getTicketNumberFormated(passengerChild.ticketNumber) ===
              getTicketNumberFormated(passengerVerify.ticketNumber) ||
            getTravellerInfoKeyPassenger(passengerChild) ===
              getTravellerInfoKeyPassenger(passengerVerify)
        )
        .value().length > 0;
  }
  return isSplited;
}


// WEBPACK FOOTER //
// ./src/services/detail/PnrToPnrItemModelAssembler.js